import { Component, type ErrorInfo, type ReactNode } from "react";
import { reportError } from "../lib/errors";

/** A screen that crashes while rendering is reported, and the reader gets a way out. */
export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    reportError("render", Object.assign(error, { stack: `${error.stack ?? ""}${info.componentStack ?? ""}` }));
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="banner">
        <b>Something went wrong</b>
        <p>We have been told about it. Reloading usually fixes it.</p>
        <div className="row">
          <button type="button" className="btn small" onClick={() => location.reload()}>
            Reload
          </button>
        </div>
      </div>
    );
  }
}
